import type { SearchControlAction } from '@splunk/dashboard-types';

export const shouldPause = ({
    isPaused,
    action,
}: {
    isPaused: boolean;
    action: SearchControlAction;
}) => !isPaused && (action === 'pause' || action === 'togglePause');
